export default {
    dms: {
        login: {
            invalid: {
                title  : "ELO Anmeldung nicht möglich",
                message: "Die Login Kennung und/oder das Passwort für die Anmeldung an ELO ist nicht korrekt. Bitte die gültigen Zugangsdaten unter den persönlichen Einstellungen im Liftmanager 4 hinterlegen."
            }
        },

        notavailible: {
            title  : "ELO nicht verfügbar",
            message: "Die Verbindung zu ELO kann nicht aufgebaut werden. Bitte prüfen, ob die Verbindung zum Hundt Netzwerk über VPN besteht. Es kann mit der Anwendung gearbeitet werden, jedoch findet keine Synchronistation mit ELO statt."
        },

        message: {
            siteNotSynccronized: "Die Anlage wurde noch nicht mit dem DMS synchronisiert. Für Ereignisse der Anlage können keine Dokumente verarbeitet werden."
        },

        document: {
            mainparent: {
                notfound: {
                    title  : "DMS Fehler",
                    message: "Für Dokument mit der GUID {0}, wurden nur Referenzen gefunden {1} "
                }
            },
            notfound: "Das Dokument konnte nicht aus ELO gelesen werden"
        },

        refresh: {
            tooltip: "Die Ordner mit dem DMS synchronisieren"
        },

        customer: {
            notfound: {
                title  : "Kunde hat im DMS kein gültiges Verzeichnis",
                message: "Für den Kunden konnte kein entsprechenes Verzeichnis im DMS gefunden werden."
            }
        },

        tree: {
            expand: "alle Verzeichnisse öffnen",
            collapse: "alle Verzeichnisse schliessen",
            reload: "Dokumente erneut laden",
            elo: {
                outstanding: "Das Verzeichnis wurde im DMS noch nicht angelegt"
            }
        },

        upload: {
            title    : "Dokumente",
            mousehint: "Zum Upload Maus loslassen",
        },

        entry: {
            menu: {
                show    : "Anzeigen",
                fadein  : "Einblenden",
                download: "Download",
                info    : "Informationen",
                props   : "Eigenschaften",
                detach  : "vom Ereignis lösen",
                replace : "Ersetzen",
                versions: "Versionen",
                combine : "Zusammenfassen",
                move    : "Verschieben",
                stamp   : "Stempeln"
            },

            message: {
                uploaded  : "Das Dokument wurde verarbeitet.",
                removed   : "Das Dokument wurde gelöscht",
                replaced  : "Das Dokument wurde ersetzt.",
                properties: "Die Eigenschaften des Dokuments wurden geändert.",
                type      : "Die Dokumentenart wurde geändert.",
                move      : "Das Dokument wurde verschoben",
                version: {
                    restored: "Der Version wurde wieder hergestellt.",
                    removed : "Die Version wurde gelöscht",
                }
            }
        },

        props: {
            store: "Übernehmen",
            assign: {
                all : "Dokument für alle Anlagen",
                unit: "Dokument nur für Anlage {0}"
            }
        },

        info: {
            name        : "Name" ,
            size        : "Größe",
            createdBy   : "Erstellt von",
            createdDate : "Erstellta am",
            modifiedBy  : "Letzte Änderung von",
            modifiedDate: "Letzte Änderung am",
            filetype    : "Dateityp",
            reference   : "Referenzen",
            id          : "ID"
        },

        version: {
            menu: {
                remove: "Version löschen",
                restore : "Version wieder herstellen"
            },
            confirm: {
                delete: {
                    query: "Version löschen?",
                    text : "Mit <b>JA</b> wird die Version des Dokumentes unwideruflich gelöscht. Soll die Löschung nun durchgeführt werden?"
                },

                restore: {
                    query: "Version wieder herstellen?",
                    text : "Mit <b>JA</b> wird die Version des Dokumentes wieder hergestellt. Soll die Wiederherstellung nun durchgeführt werden?"
                }
            }
        },

        assign: {
            all : "alle Anlagen",
            unit: "Anlage {0}"
        },

        combine: {
            label         : "Zusammenfassen",
            targetstep    : "Dokument ablegen in ...",
            targetfile    : "Dateiname",
            targetfilename: "Zusammenfassung.pdf",
            success       : "Die Datei {0} wurde erstellt.",
            error: {
                empty     : "Es wurde keine Dokumente ausgewählt.",
                invalid   : "Es werden mindestens 2 Dokumente benötigt.",
                filename  : "Der Dateiname muss angegeben werden",
                to        : "verschieben nach ..."
            }
        },

        move: {
            label         : "Verschieben",
            to            : "verschieben nach ..."
        }
    },
}